import { call, put, takeLatest } from 'redux-saga/effects';
import * as messagingActions from '../actions/messaging';
import * as api from '../api/messaging';
const { messagingGetApps, messagingSetApps, messagingAddApp, messagingDeleteApp, messagingGetHooks, messagingSetHooks, messagingAddPage, messagingDeletePage, messagingDeleteInstagramAccount, messagingUpdatePage, messagingUpdateInstagramPage, messagingSetAsyncStatus, messagingUpdateAccessToken, } = messagingActions.actions;
export const messaging = [
    takeLatest(messagingGetApps.toString(), function* (action) {
        let result;
        yield put(messagingSetAsyncStatus({ status: 'loading' }));
        try {
            result = yield call(api.getMessagingList, action.payload);
            yield call(action.meta.resolve, result);
            yield put(messagingSetApps(result.data));
        }
        catch (exception) {
            console.warn(exception);
            // Something went wrong. We reject the promise.
            yield call(action.meta.reject, exception);
            result = exception;
            yield put(messagingSetAsyncStatus({ status: 'failed' }));
        }
    }),
    takeLatest(messagingAddApp.toString(), genWithPromise(api.addMessagingApp, messagingSetAsyncStatus)),
    takeLatest(messagingDeleteApp.toString(), genWithPromise(api.deleteMessagingApp, messagingSetAsyncStatus, messagingGetApps)),
    takeLatest(messagingGetHooks.toString(), genWithPromise(api.getMessagingHooks, messagingSetAsyncStatus, messagingSetHooks)),
    takeLatest(messagingAddPage.toString(), genWithPromise(api.addMessagingPage, messagingSetAsyncStatus)),
    takeLatest(messagingDeletePage.toString(), genWithPromise(api.deleteMessagingPage, messagingSetAsyncStatus, messagingGetApps)),
    takeLatest(messagingDeleteInstagramAccount.toString(), genWithPromise(api.deleteMessagingInstagramAccount, messagingSetAsyncStatus, messagingGetApps)),
    takeLatest(messagingUpdatePage.toString(), genWithPromise(api.updateMessagingPage, messagingSetAsyncStatus, messagingGetApps)),
    takeLatest(messagingUpdateInstagramPage.toString(), genWithPromise(api.updateInstagramPage, messagingSetAsyncStatus, messagingGetApps)),
    takeLatest(messagingUpdateAccessToken.toString(), genWithPromise(api.updateMessagingAccessToken, messagingSetAsyncStatus, messagingGetApps)),
];
function genWithPromise(apiAction, statusAction, successAction) {
    return function* (action) {
        let result;
        yield put(statusAction({ status: 'loading' }));
        try {
            result = yield call(apiAction, action.payload);
            yield call(action.meta.resolve, result);
            yield put(statusAction({ status: 'succeeded' }));
            if (successAction) {
                yield put(successAction(result.data));
            }
        }
        catch (exception) {
            console.warn(exception);
            // Something went wrong. We reject the promise.
            yield call(action.meta.reject, exception);
            result = exception;
            yield put(statusAction({ status: 'failed' }));
        }
    };
}
